import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Plus } from "lucide-react";

const empty = {
  name: "", country: "", manufacturing_site: "", product_list: "",
  status: "pending_review", notes: "",
};

export default function Suppliers() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(empty);

  const load = () => api.get("/admin/suppliers").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const create = async () => {
    if (!form.name) { toast.error("Name required"); return; }
    await api.post("/admin/suppliers", form);
    toast.success("Supplier added");
    setForm(empty); load();
  };

  return (
    <div className="max-w-screen-2xl mx-auto px-6 py-10">
      <div className="label-eyebrow">Supply chain</div>
      <h1 className="text-2xl font-bold tracking-tight mt-1">Suppliers</h1>

      <div className="mt-6 border border-[#D1D5DB] p-5">
        <div className="label-eyebrow mb-3"><Plus className="inline h-3.5 w-3.5 mr-1" /> Register supplier</div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <F label="Supplier name" v={form.name} on={(v) => setForm({ ...form, name: v })} test="sup-name" />
          <F label="Country" v={form.country} on={(v) => setForm({ ...form, country: v })} test="sup-country" />
          <F label="Manufacturing site" v={form.manufacturing_site} on={(v) => setForm({ ...form, manufacturing_site: v })} test="sup-site" />
          <F label="Product list (free-text)" v={form.product_list} on={(v) => setForm({ ...form, product_list: v })} test="sup-list" />
          <div className="md:col-span-2">
            <label className="label-eyebrow block mb-1">Notes</label>
            <textarea rows={2} value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} className="w-full p-2 border border-[#D1D5DB] text-sm" data-testid="sup-notes" />
          </div>
        </div>
        <button onClick={create} className="btn-primary mt-4" data-testid="sup-create">Register</button>
      </div>

      <div className="mt-8 border border-[#D1D5DB]">
        <table className="w-full data-table">
          <thead><tr><th className="text-left px-4 py-2">Name</th><th className="text-left px-4 py-2">Country</th><th className="text-left px-4 py-2">Site</th><th className="text-left px-4 py-2">Status</th></tr></thead>
          <tbody>
            {items.map((s) => (
              <tr key={s.id}>
                <td className="px-4 py-3">{s.name}</td>
                <td className="px-4 py-3 font-mono text-xs">{s.country}</td>
                <td className="px-4 py-3 text-xs">{s.manufacturing_site}</td>
                <td className="px-4 py-3 font-mono text-[11px] uppercase tracking-wider">{s.status?.replace(/_/g, " ")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const F = ({ label, v, on, test }) => (
  <div>
    <label className="label-eyebrow block mb-1">{label}</label>
    <input value={v} onChange={(e) => on(e.target.value)} className="w-full px-3 py-2 border border-[#D1D5DB] bg-white text-sm" data-testid={test} />
  </div>
);
